module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/authentication/verfication/verfication.component.scss
// module id = ./src/app/authentication/verfication/verfication.component.scss
// module chunks = main